import Vue from 'vue'
import Vuex from 'vuex'

import user from "./modules/user";
import boutique_bo from "./modules/boutique_bo";
import boutique from "./modules/boutique";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    boutique_bo,
    boutique,
  }
})
